import { render, staticRenderFns } from "./HeaderSign.vue?vue&type=template&id=1fa0a825"
import script from "./HeaderSign.vue?vue&type=script&lang=js"
export * from "./HeaderSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports